import { render } from "./HeroiconsSolidPhoneOutgoing.vue?vue&type=template&id=191d014a"
const script = {}

import exportComponent from "/home/harlan/sites/kintell-env/api/packages/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidPhoneOutgoing.vue"]])

export default __exports__